var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { ControlWrapper, ControlButton, ControlPageCount, } from "./components";
import { GN } from "@lib/common";
let ProtableControls = class ProtableControls extends React.Component {
    timeout;
    constructor(props) {
        super(props);
        this.state = {
            pageInput: "1"
        };
    }
    changePage = (forward) => {
        const { store, onPageChange } = this.props;
        const s = store.s;
        if (forward) {
            if (s.page + 1 <= store.totalPages) {
                const page = s.page + 1;
                if (onPageChange)
                    onPageChange(page);
                store.setPage(page);
                this.setState({
                    pageInput: page.toString()
                });
            }
        }
        else if (s.page - 1 >= 1) {
            const page = s.page - 1;
            if (onPageChange)
                onPageChange(page);
            store.setPage(page);
            this.setState({
                pageInput: page.toString()
            });
        }
    };
    setFirstPage = () => {
        const { store, onPageChange } = this.props;
        const s = store.s;
        if (s.page !== 1) {
            if (onPageChange)
                onPageChange(1);
            store.setPage(1);
            this.setState({
                pageInput: "1"
            });
        }
    };
    setLastPage = () => {
        const { store, onPageChange } = this.props;
        const s = store.s;
        if (s.page !== store.totalPages) {
            if (onPageChange)
                onPageChange(store.totalPages);
            store.setPage(store.totalPages);
            this.setState({
                pageInput: store.totalPages.toString()
            });
        }
    };
    componentWillUnmount() {
        if (this.timeout) {
            if (this.timeout) {
                window.clearTimeout(this.timeout);
            }
        }
    }
    render() {
        const { store, onPageChange } = this.props;
        const { pageInput } = this.state;
        const s = store.s;
        return (React.createElement(ControlWrapper, null,
            React.createElement(ControlButton, { onClick: this.setFirstPage }, "First"),
            React.createElement(ControlButton, { onClick: () => this.changePage(false) }, "Previous"),
            React.createElement(ControlPageCount, null,
                React.createElement("input", { type: "number", value: pageInput, max: store.totalPages, step: 1, min: 1, onChange: (e) => {
                        const { value } = e.target;
                        this.setState({
                            pageInput: value
                        });
                        clearTimeout(this.timeout);
                        this.timeout = setTimeout(() => {
                            if (value === "")
                                return;
                            const page = Number(value);
                            if (!Number.isNaN(page) && page >= 1 && page <= store.totalPages) {
                                onPageChange?.(page);
                                store.setPage(page);
                            }
                            else {
                                GN.add({
                                    type: "warning",
                                    duration: 1000,
                                    message: "Invalid page number"
                                });
                            }
                        }, 500);
                    }, onBlur: () => {
                        if (pageInput === "") {
                            this.setState({
                                pageInput: String(s.page)
                            });
                        }
                    } }),
                "/ ",
                store.totalPages),
            React.createElement(ControlButton, { onClick: () => this.changePage(true) }, "Next"),
            React.createElement(ControlButton, { onClick: this.setLastPage }, "Last")));
    }
};
ProtableControls = __decorate([
    observer
], ProtableControls);
export { ProtableControls };
//# sourceMappingURL=controls.js.map